import axios from 'axios';

import { Id, PagedResponse, getData } from '@feature/utils';

import { LocalUserParams, User, UserCreateRequest } from './UserTypes';

export function getLocalPaged(params: LocalUserParams) {
  return axios.get<PagedResponse<User>>('/users/local', { params }).then(getData);
}

export function create(request: UserCreateRequest) {
  return axios.post<User>('/users', request).then(getData);
}

export function reissueTemporaryPassword(id: Id) {
  return axios.post<unknown>(`/users/${id}/temporary-password`).then(getData);
}
